module.exports = __webpack_public_path__ + "static/img/layout-img@w.d7e401e.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/lotte-group/layout-img@w.png
// module id = O42E
// module chunks = 0